import { SplitTreatments } from '@splitsoftware/splitio-react';

export interface SplitWrapperProps {
  treatmentName: string;
  children: JSX.Element;
  attributes?: Record<string, string>;
}

export const SplitWrapper = (props: SplitWrapperProps): JSX.Element => {
  const { treatmentName, children, attributes = {} } = props;
  return (
    <SplitTreatments names={[treatmentName]} attributes={attributes}>
      {({ isReady, treatments }): JSX.Element => {
        if (
          isReady &&
          treatments[treatmentName] &&
          treatments[treatmentName].treatment === 'on'
        ) {
          return children;
        }
        return <></>;
      }}
    </SplitTreatments>
  );
};
